import { ValidationError } from "./orderUtils";

export const scrollToElement = (element: HTMLElement | null) => {
  if (!element) return;

  const offset = 100; // Offset from the top of the viewport in pixels
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

// Enhanced error scrolling with focus management
export const scrollToError = (
  fieldId: string | null,
  formRefs: Record<string, HTMLElement | null>
) => {
  if (!fieldId || !formRefs[fieldId]) return;

  const errorElement = formRefs[fieldId];
  if (errorElement) {
    // Scroll to the element
    scrollToElement(errorElement);

    // Try to focus the element after scrolling (for keyboard navigation)
    setTimeout(() => {
      try {
        if (
          errorElement instanceof HTMLInputElement ||
          errorElement instanceof HTMLSelectElement ||
          errorElement instanceof HTMLTextAreaElement
        ) {
          errorElement.focus();
        }
      } catch (e) {
        console.error("Failed to focus element:", e);
      }
    }, 500);
  }
};

export const scrollToNextSection = (element: HTMLElement | null) => {
  if (!element) return;

  const offset = 30; // Smaller offset for section transitions
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

export const lockBodyScroll = () => {
  document.body.style.overflow = "hidden";
};

export const unlockBodyScroll = () => {
  document.body.style.overflow = "";
};
